const get = require('lodash/get')
const { listProductsForPrograms } = require('./list-for-programs-services')
const utils = require('./../../utils')

exports.exportProducts = async (state, opts) => {
  const userPrograms = get(state, 'user.programs', [])
  const products = await listProductsForPrograms(state, userPrograms)
  return utils.sheet.encode(products, opts)
}
